<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-06-28 13:27:43
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-09-26 16:59:42
 * @FilePath: /wemeet-admin-new/src/views/data/components/exhibitiorAndExhibiti.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-row>
    <div class="dialogCard" style="margin-top: 20px">
      <div class="subBox">
        <div class="title">机构产品</div>
        <div class="subTitle">更新时间：{{ nowTime }}</div>
      </div>

      <el-row style="width: 100%">
        <el-col
          v-for="(item, index) in interactionData"
          :key="index"
          class="ul"
          :lg="12"
          :md="12"
          :sm="12"
          :xl="12"
          :xs="24"
        >
          <p class="smTitle">{{ item.name }}</p>
          <div v-if="loading">加载中...</div>
          <template v-else>
            <vab-count
              :decimals="item.countConfig.decimals"
              :duration="item.countConfig.duration"
              :end-val="item.countConfig.endVal"
              :prefix="item.countConfig.prefix"
              :separator="item.countConfig.separator"
              :start-val="item.countConfig.startVal"
              style="font-size: 26px; color: #1d2129; font-weight: bold"
            />
            <span style="font-size: 16px; color: #4e5969">{{ item.countConfig.suffix }}</span>
          </template>
        </el-col>
      </el-row>
    </div>
  </el-row>
</template>

<script>
  import { defineComponent, reactive, toRefs, watch } from 'vue'
  import _ from 'lodash'
  import VabChart from '@/extra/VabChart'
  import VabCount from '@/extra/VabCount'

  export default defineComponent({
    components: {
      VabChart,
      VabCount,
    },
    props: {
      data: {
        type: Object,
        default: {},
      },
      nowTime: {
        type: String,
        default: '',
      },
      meetingType: {
        type: String,
        default: '',
      },
    },
    setup(props) {
      watch(
        () => props.data,
        (newVal, oldVal) => {
          state.interactionData[0].countConfig.endVal = newVal.exhibitorNum
          state.interactionData[1].countConfig.endVal = newVal.exhibitNum

          setTimeout(() => {
            state.loading = false
          }, 100)
        }
      )
      const state = reactive({
        loading: true,
        interactionData: [
          {
            countConfig: {
              startVal: 0,
              endVal: 0,
              decimals: 0,
              prefix: '',
              suffix: '个',
              separator: ',',
              duration: 3000,
            },
            name: '机构数量',
            colCount: 8,
          },
          {
            countConfig: {
              startVal: 0,
              endVal: 0,
              decimals: 0,
              prefix: '',
              suffix: '个',
              separator: ',',
              duration: 3000,
            },
            name: '产品数量',
            colCount: 8,
          },
        ],
      })
      return {
        ...toRefs(state),
      }
    },
  })
</script>

<style lang="scss" scoped>
  .dialogCard {
    width: 100%;
    min-height: 174px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    padding: 20px;
    box-sizing: border-box;
    .subBox {
      .title {
        font-weight: 500;
        font-size: 16px;
        color: #1d2129;
        margin-bottom: 4px;
      }
      .subTitle {
        font-size: 12px;
        color: #4e5969;
      }
    }

    .ul {
      margin-top: 15px;
      .smTitle {
        font-size: 16px;
        color: #1d2129;
      }
    }
  }
</style>
